import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class JIPSService {
    
    private JIPSData = {
        '4': 'MB',
        '2': 'MBO',
        '3': 'MIBPG',
        '5': 'RBO',
        '6': 'OIB',
        '1': 'OIB'
    }

    public getJipsData(data: number): string | null {
        if(data == 1) {
            return this.JIPSData['1'];
        }else if(data == 4) {
            return this.JIPSData['4'];
        }else if(data == 2) {
            return this.JIPSData['2'];
        }else if(data == 3) {
            return this.JIPSData['3'];
        }else if(data == 6) {
            return this.JIPSData['6'];
        }else if(data == 5) {
            return this.JIPSData['5'];
        }
        else {
            return null;
        }
    }
}